import { useCallback } from 'react';

import { IconPound } from '@iwoca/icons';
import { Input } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';

import {
  formatLoanAmountUK,
  MAX_LOAN_AMOUNT_UK,
  TLoanFieldsDataUK,
} from './loanOptions';

type TProps = {
  label?: string;
  placeholder?: string;
};

const AmountInputUK = ({
  label = 'How much would you like?',
  placeholder = `Up to ${formatLoanAmountUK(MAX_LOAN_AMOUNT_UK)}`,
}: TProps) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<TLoanFieldsDataUK>();

  const formatCurrency = useCallback(() => {
    const amount = watch('amount')?.replace(/[^0-9]+/g, '');
    if (!amount) return '';

    return parseInt(amount).toLocaleString('en-GB');
  }, [watch]);

  return (
    <Input
      {...register('amount')}
      value={formatCurrency()}
      iconLeft={<IconPound />}
      label={label}
      placeholder={placeholder}
      error={errors.amount?.message}
    />
  );
};

export default AmountInputUK;
